export interface Vetor3 {
  x: number
  y: number
  z: number
}

export const vetor = (x: number, y: number, z: number): Vetor3 => ({ x, y, z })

export const deArray = ([x, y, z]: [number, number, number]): Vetor3 => ({ x, y, z })
export const paraArray = (v: Vetor3): [number, number, number] => [v.x, v.y, v.z]

export const somar = (a: Vetor3, b: Vetor3): Vetor3 => vetor(a.x + b.x, a.y + b.y, a.z + b.z)
export const subtrair = (a: Vetor3, b: Vetor3): Vetor3 => vetor(a.x - b.x, a.y - b.y, a.z - b.z)
export const multiplicar = (v: Vetor3, escalar: number): Vetor3 => vetor(v.x * escalar, v.y * escalar, v.z * escalar)
export const dot = (a: Vetor3, b: Vetor3): number => a.x * b.x + a.y * b.y + a.z * b.z
export const cross = (a: Vetor3, b: Vetor3): Vetor3 => vetor(
  a.y * b.z - a.z * b.y,
  a.z * b.x - a.x * b.z,
  a.x * b.y - a.y * b.x,
)
export const comprimento = (v: Vetor3): number => Math.hypot(v.x, v.y, v.z)

export function normalizar(v: Vetor3, tolerancia = 1e-9): Vetor3 {
  const tamanho = comprimento(v)
  if (tamanho < tolerancia) throw new Error('Não é possível normalizar um vetor nulo.')
  return multiplicar(v, 1 / tamanho)
}

export const projetarNoPlano = (v: Vetor3, normal: Vetor3): Vetor3 => {
  const n = normalizar(normal)
  return subtrair(v, multiplicar(n, dot(v, n)))
}

export const limitar = (valor: number, minimo: number, maximo: number): number =>
  Math.max(minimo, Math.min(maximo, valor))

export const grausParaRad = (graus: number): number => (graus * Math.PI) / 180
export const radParaGraus = (rad: number): number => (rad * 180) / Math.PI

export function girarEmTorno(v: Vetor3, eixo: Vetor3, anguloRad: number): Vetor3 {
  const n = normalizar(eixo)
  const cos = Math.cos(anguloRad)
  const sin = Math.sin(anguloRad)
  return somar(
    somar(multiplicar(v, cos), multiplicar(cross(n, v), sin)),
    multiplicar(n, dot(n, v) * (1 - cos)),
  )
}
